import {IGeoLocationService} from "./geo-location.service.interface";
import {ServiceBase} from "../ServiceBase";
import {IModalDialogButtonsComponentProps} from "../../components/modal-dialog/modal-dialog-actions.component";

export class GeoLocationService extends ServiceBase implements IGeoLocationService {
    startGeoLocationOnOpenRealGame(): Promise<void> {
        return this.services.sdk.startGeoLocationOnOpenRealGame();
    }

    isEligibleForGameGeoRetry(): boolean {
        return this.services.sdk.isEligibleForGameGeoRetry();
    }

    getButtonsForNonRetryGeoFlow(): IModalDialogButtonsComponentProps {
        return this.services.sdk.getButtonsForNonRetryGeoFlow();
    }

    getRetryMessageButtons(analyticsLabel: string, resolve?, reject?): IModalDialogButtonsComponentProps {
        return this.services.sdk.getRetryMessageButtons(analyticsLabel, resolve, reject);
    }
}